import { Component, EventEmitter, HostListener, inject, Output, signal } from '@angular/core';
import { form, minLength, required, FormField } from '@angular/forms/signals';
import { AddDocumentComponent } from '../../../../atoms/add-document/add-document.component';
import { WysiswygComponent } from '../../../../atoms/wysiswyg/wysiswyg.component';
import { ComplianceDocsService } from '../../../../services/compliance-docs/compliance-docs.service';
import { LoadingInlineComponent } from '../../../../atoms/loading-inline/loading-inline.component';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { ViewportOverlayDirective } from '../../../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'mb-compliance-create',
  standalone: true,
  imports: [FormField, AddDocumentComponent, WysiswygComponent, LoadingInlineComponent],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './compliance-create.component.html',
  styleUrl: './compliance-create.component.css'
})
export class ComplianceCreateComponent {

  @Output() close = new EventEmitter<boolean>();

  briefProvisionOptions: { id: number, name: string, description: string }[] = [
    { id: 1, name: 'Upload Document', description: 'Upload a PDF or Word document defining your brief.' },
    { id: 2, name: 'Type Requirements', description: 'Manually enter the brief requirements.' }
  ]


  submittingCompliance = signal<boolean>(false);
  complianceCreated = signal<boolean>(false);
  complianceService = inject(ComplianceDocsService);
  currentUserService = inject(CurrentUserService);
  selectedComplianceProvision = signal<{ id: number, name: string, description: string } | undefined>(undefined);

  complianceModel = signal({
    complianceName: '',
    subHeading: '',
    description: '',
    complianceContent: '',
    complianceDocumentUrl: '',
    hilOn: false,
    businessAccountId: this.currentUserService.focussedBrand.id,
  })
  complianceForm = form(this.complianceModel, (schemaPath) => {
    required(schemaPath.complianceName, { message: 'Compliance Name is required' });
    minLength(schemaPath.complianceName, 2, { message: 'Compliance Name must be at least 2 characters long' });
    required(schemaPath.description, { message: 'Compliance Description is required' });
    minLength(schemaPath.description, 20, { message: 'Compliance Description must be at least 20 characters long' });
  })

  @HostListener('document:keydown.escape', ['$event' as any])
  handleEscapeKey(event: KeyboardEvent) {
    this.closePanel();
  }

  onDocumentUploaded(event: { file: string, fileKey: string, fullUrl: string }) {
    console.log('event: ', event);
    this.complianceModel.set({ ...this.complianceModel(), complianceDocumentUrl: event.fullUrl });
  }
  onHtmlContentChange(event: string, key: string) {
    console.log('onHtmlContentChange() -> ', event);
    this.complianceModel.set({ ...this.complianceModel(), complianceContent: event });
  }

  saveCompliance() {
    console.log('saveCompliance() -> ');
    console.log('Compliance Form: ', this.complianceModel());
    this.submittingCompliance.set(true);
    this.complianceService.createComplianceDoc(this.complianceModel()).subscribe((response) => {
      console.log('Compliance created: ', response);
      this.submittingCompliance.set(false);
      this.complianceCreated.set(true);
    }, (error) => {
      console.error('Error creating compliance: ', error);
      this.submittingCompliance.set(false);
    });
  }

  closePanel() {
    this.close.emit(true);
  }

}
